import React from 'react';
import { Link } from 'react-router-dom';
import { RoughNotation, RoughNotationGroup } from 'react-rough-notation';
import { useNavigate } from 'react-router-dom';

function WelcomeBanner() {
    const navigate = useNavigate();
    return (
        <div className="w-full">
            {/* NDIS Banner Section */}
            <div className="relative w-full bg-[#336fb8] overflow-hidden">
                <div className="flex container flex-col md:flex-row justify-between items-center mx-auto">
                    {/* Left Content */}
                    <div className="w-full md:w-1/2 text-white px-6 md:px-16 py-8 md:py-16 z-10 relative">
                        <h1 className="font-arial-rounded text-3xl md:text-5xl mb-4 lg:text-7xl text-white font-bold inline-block px-4">
                            Livability Care Australia
                        </h1>
                        <h2 className="text-2xl md:text-4xl font-arial-rounded font-normal italic mb-4">
                            <span className="text-yellow-400">
                                <span className="text-yellow-400">"</span>Because Care Begins at Home</span><span className="text-yellow-400">"</span>
                                </h2>
                        <div className="w-1/3 h-[3px] bg-white mt-2 mb-6"></div>
                        
                        <p className="text-lg md:text-2xl mb-8">
                            Livability Care Australia is a NDIS registered 
                            disability services provider in Australia.
                        </p>
                        
                        {/* Buttons */}
                        <div className="flex flex-col md:flex-row gap-4">
                            <button 
                                className="bg-secondary-green font-bold text-white px-8 md:px-16 py-3 rounded-3xl text-base md:text-lg"
                                onClick={() => navigate('/contact')}
                            >
                                Contact us
                            </button>
                            <button 
                                className="bg-primary text-white font-bold px-8 md:px-16 py-3 rounded-3xl text-base md:text-lg"
                                onClick={() => navigate('/properties')}
                            >
                                Vacancies
                            </button>
                        </div>
                    </div>
                    
                    {/* Right Circles */}
                    <div className="absolute right-0 top-0 w-full md:w-[55%] h-full opacity-25 md:opacity-100">
                        {/* Yellow circle */}
                        <div className="absolute top-0 right-0 w-32 sm:w-48 md:w-64 h-32 sm:h-48 md:h-64 rounded-full bg-primary-yellow
                                transform translate-x-6 sm:translate-x-12 -translate-y-2 sm:-translate-y-4" />
                        
                        {/* Green circle */}
                        <div className="absolute bottom-0 right-40 sm:right-80 w-32 sm:w-48 md:w-64 h-32 sm:h-48 md:h-64 rounded-full bg-white
                                transform translate-x-12 sm:translate-x-24 translate-y-6 sm:translate-y-12" />
                        
                        {/* Main white circle with image */}
                        <div className="absolute top-0 right-0 w-[300px] h-[300px] sm:w-[400px] sm:h-[400px] md:w-[450px] md:h-[450px] rounded-full bg-primary  
                                transform translate-x-4 sm:translate-x-8 md:translate-x-12 translate-y-4 sm:translate-y-8 overflow-hidden">
                        </div>
                        
                        {/* Purple border circle */}
                        <div className="absolute top-0 right-0 w-[320px] h-[320px] sm:w-[420px] sm:h-[420px] md:w-[470px] md:h-[470px] rounded-full 
                                transform translate-x-6 sm:translate-x-12 md:translate-x-16 translate-y-2 sm:translate-y-4
                                border-4 border-white" />

                        <img 
                            src="/Website_Title_Images/Home.svg"
                            alt="Title Banner"
                            className="absolute w-[80%] sm:w-[85%] md:w-[90%] right-0 bottom-0 object-cover"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WelcomeBanner;